module.exports = __webpack_public_path__ + "static/media/auchan7.1f2ca898.jpg";